import { useContext, useCallback, useRef } from "react";
import { context } from "../../context/authContext";
import useApi from "../../helpers/api";

export default function useActions() {
  const { user } = useContext(context);
  const api = useApi();
  const retryCount = useRef(0);

  const validateCell = (field, value) => {
    // if (!value) return `${field} No puede estar vacío.`;//!Ver la forma de no validar los campos opcionales
    const validators = {
      nombre: /\S.{0,44}$/,
      email: /^.{1,45}$/,
      emailFormat: /^\S+@\S+\.\S+$/,
      password: /^(?=.*[A-Z])(?=.*\d).{8,45}$/,
    };

    if ((field === "nombre" && !validators.nombre.test(value)) || !value) return "Nombre debe tener entre 1 y 45 caracteres.";
    if (field === "email") {
      if ((!validators.email.test(value)) || !value) return "Email debe tener entre 1 y 45 caracteres.";
      if ((!validators.emailFormat.test(value)) || !value) return "Formato de email inválido.";
    }
    if ((field === "password" && !validators.password.test(value)) || !value)
      return "Contraseña inválida (entre 8 y 45 caracteres, al menos 1 May, al menos 1 num).";
    
    return "";
  };

  const onCellEditingStopped = useCallback(async (event, gridRef) => {
    try {
      if (!gridRef.current) return;

      const rowData = event.data;
      const colField = event.colDef.field;
      const errorMessage = validateCell(colField, event.newValue);
      const isNewRow = String(rowData.id).length >= 8;

      if (errorMessage) {
        rowData[`tooltipError${colField}`] = errorMessage;
        await gridRef.current.api.refreshCells({ rowNodes: [event.node], columns: [colField], force: true });

        rowData[colField] = event.oldValue;
        if (colField === "password" && retryCount.current >= 1) {
          rowData[`tooltipError${colField}`] = "";
          gridRef.current.api.refreshCells({ force: true });
          retryCount.current = 0;
          return;
        }
        return;
      }

      rowData[`tooltipError${colField}`] = "";
      rowData[`isValid${colField}`] = true;
      gridRef.current.api.refreshCells({ force: true });

      setTimeout(() => {
        rowData[`isValid${colField}`] = false;
        gridRef.current.api.refreshCells({ force: true });
      }, 1000);

      if (isNewRow) {
        if (!rowData[colField]) {
          alert(`Field ${colField} cannot be empty.`);
          gridRef.current.api.applyTransaction({ remove: [rowData] });
          return;
        }

        if (rowData.nombre && rowData.email && rowData.password && !rowData.tooltipErroremail && !rowData.tooltipErrornombre && !rowData.tooltipErrorpassword) {
          delete rowData.id;
          const newUser = await api.createUsuario(rowData);
          if(!!newUser.errors){
            let msgs = '';
            for(const error of newUser.errors){
              msgs += `${error.message}.\n`;
            }
            alert(`Error: \n${msgs}`)
            // gridRef.current.api.applyTransaction({ remove: [rowData] });
          }else{
            event.node.setData({ ...rowData, id: newUser.id, empresa: newUser.empresa });
          }
        }
      } else {
        if (event.newValue !== event.oldValue) {
          await api.updateUsuario(rowData);
        }
      }
    } catch (error) {
      console.error("Error in onCellEditingStopped:", error);
    }
  }, [api]);

  const createHook = async (gridRef) => {
    if (!gridRef.current) return;

    const newRow = { id: Date.now(), nombre: "", email: "", rol: "4", empresa: user.empresa };
    gridRef.current.api.applyTransaction({ add: [newRow] });

    setTimeout(() => {
      const rowNode = gridRef.current.api.getRowNode(newRow.id.toString());
      rowNode?.setSelected(true);
      gridRef.current.api.startEditingCell({
        rowIndex: gridRef.current.api.getDisplayedRowCount() - 1,
        colKey: "nombre",
      });
    }, 10);
  };

  const handleDelete = (rowData, setSelectedRow,setModalOpen) => {
    setSelectedRow(rowData);
    setModalOpen(true);
  }

  const confirmDelete = async (gridRef, selectedRow, setModalOpen, setSelectedRow) => {
    if (!gridRef.current || !selectedRow) return;

    try {
      const response = await api.borrarUsuario(selectedRow.data.id);
      if (response.status === 200) {
        gridRef.current.api.applyTransaction({ remove: [selectedRow.data] });
      } else if(response.status === 404){
        gridRef.current.api.applyTransaction({ remove: [selectedRow.data] });
      }
    } catch (error) {
      console.error("Error deleting row:", error);
    } finally {
      setModalOpen(false);
      setSelectedRow(null);
    }
  };

  return { handleDelete, createHook, onCellEditingStopped, validateCell, confirmDelete };
}
